module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "m-b-md"
  }, [_c('el-dropdown', {
    staticClass: "pull-right",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-more",
      "plain": ""
    }
  }, [_vm._v("More Options")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "edit-campaign"
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "campaign-report"
    }
  }, [_vm._v("Campaign Report")]), _vm._v(" "), (_vm.survey) ? _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "survey-report"
    }
  }, [_vm._v("Survey Report")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bots.length ? true : false),
      expression: "bots.length ? true : false"
    }],
    attrs: {
      "command": "bot-report"
    }
  }, [_vm._v("Bot Report\n              ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "download-messages"
    }
  }, [_vm._v("Download messages")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "random-select"
    }
  }, [_vm._v("Select a random winner")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "random-selection"
    }
  }, [_vm._v("Random selections")]), _vm._v(" "), _c('can', {
    attrs: {
      "action": "view",
      "subject": "campaigns-offline"
    }
  }, [(_vm.live) ? _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "toggle-live-status"
    }
  }, [_vm._v("Take Offline")]) : _vm._e()], 1), _vm._v(" "), (!_vm.live) ? _c('el-dropdown-item', {
    attrs: {
      "divided": true,
      "command": "toggle-live-status"
    }
  }, [_vm._v("Take Online")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "favourite active pull-left",
    class: {
      active: _vm.isFavourite, inactive: !_vm.isFavourite
    },
    on: {
      "click": _vm.handleToggleFavourite
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: {
      'fa-star': _vm.isFavourite, 'fa-star-o': !_vm.isFavourite
    }
  })]), _vm._v(" "), _c('h2', [_c('router-link', {
    attrs: {
      "to": ("/campaigns/" + _vm.id)
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Status:")]), _vm._v(" "), _c('dd', [(_vm.live) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (!_vm.live) ? _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("Inactive")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Type:")]), _vm._v(" "), _c('dd', [(_vm.campaignType === 'COMPETITION') ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Competition")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'MESSAGE_BOARD') ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Message Board")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'POLL') ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Poll")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'SURVEY') ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Survey")]) : _vm._e(), _vm._v(" "), (_vm.campaignType === 'INSTANT_POLL') ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Instant Poll")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Total Messages:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(Math.round(_vm.totalMessages).toLocaleString()))]), _vm._v(" "), _c('dt', [_vm._v("Unique Messages:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(Math.round(_vm.uniqueMessages).toLocaleString()))]), _vm._v(" "), _c('dt', [_vm._v("Growth")]), _vm._v(" "), _c('dd', [_c('growth', {
    attrs: {
      "value": _vm.growth,
      "isPercentage": true
    }
  })], 1), _vm._v(" "), (_vm.leadCount && _vm.leadCount > 0) ? _c('div', [_c('dt', [_vm._v("Lead Total:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.leadCount))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Start Date:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.startDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("End Date:")]), _vm._v(" "), (_vm.perpetual) ? _c('dd', [_c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Perpetual Campaign")])]) : _c('dd', [_vm._v(_vm._s(_vm.endDate.format('ddd Do MMMM YYYY')))]), _vm._v(" "), _c('dt', [_vm._v("Created By:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.createdBy ? _vm.createdBy.displayName : ''))]), _vm._v(" "), _c('dt', [_vm._v("Progress:")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "progress m-b-sm"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.adjustedProgress + "%")
    })
  })]), _vm._v(" "), (_vm.adjustedProgress < 100) ? _c('small', [_vm._v("\n              This campaign is currently\n              "), _c('strong', [_vm._v(_vm._s(_vm.adjustedProgress) + "%")]), _vm._v("\n              completed and will end\n              "), _c('strong', [_vm._v(_vm._s(_vm.endDate.fromNow()))]), _vm._v(".\n            ")]) : _vm._e(), _vm._v(" "), (_vm.adjustedProgress === 100) ? _c('small', [_vm._v("\n              This campaign has\n              "), _c('strong', [_vm._v("completed " + _vm._s(_vm.endDate.fromNow()))]), _vm._v(".\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.topEngagers.length) ? _c('dt', [_vm._v("Top Engagers:")]) : _vm._e(), _vm._v(" "), _c('dd', {
    staticClass: "project-people"
  }, _vm._l((_vm.topEngagers), function(profile, index) {
    return _c('engager', {
      key: index,
      attrs: {
        "profile": profile
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showProfileDialog(profile, _vm.id)
        }
      }
    })
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('small', [_vm._v("Interactions this month")]), _vm._v(" "), _c('h2', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.totalThisMonth).toLocaleString()))]), _vm._v(" "), _c('trend', {
    attrs: {
      "points": _vm.totalPerDayThisMonth,
      "height": 50
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-8': _vm.replyMessage.length > 0, 'col-lg-12': _vm.replyMessage.length === 0
    }
  }, [_c('h3', [_vm._v("Channels")]), _vm._v(" "), (_vm.channelLinks.length) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('can', {
    attrs: {
      "action": "view",
      "subject": "unlink-channels"
    }
  }, _vm._l((_vm.channelLinks), function(item) {
    return _c('channel-to-campaign-link-item', {
      key: item.id,
      attrs: {
        "keyword": item.keyword,
        "handle": item.channel.handle,
        "channelType": item.channel.channelTypeTitle
      },
      on: {
        "onUnlink": function($event) {
          return _vm.handleUnlink(item.id)
        }
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.channelLinks.length) ? _c('div', {
    staticClass: "no-channels"
  }, [_c('span', [_vm._v("You currently have no channels linked on this campaign.")])]) : _vm._e()]), _vm._v(" "), (_vm.replyMessage.length > 0) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h5', [_vm._v("Reply Messages")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('em', [_vm._v(_vm._s(_vm.replyMessage))])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e691b0e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/CampaignListItem.vue
// module id = 3410
// module chunks = 3